export default __webpack_public_path__ + "img/Bhushan.5930e8f6.png";